import { Button, Typography, useMediaQuery } from "@mui/material";
import { useState } from "react";
import menu from "../../icons/menu.svg";
import logo from "../../images/bkv_logo.svg";
import {
  HeaderContent,
  HeaderStyled,
  HeaderTitleItem,
  HeaderTitleItems,
  RightSection,
} from "../styled/Header.styled";
import { PCDrawer } from "./PcDrawer";
import { HeaderTitleArray } from "./data";
import MobileDrawer from "./MobileDrawer";

export const HeaderV2 = () => {
  const [showDrawer, setShowDrawer] = useState(false);
  const [drawerContent, setDrawerContent] = useState();
  const [showMenu, setShowMenu] = useState(false);
  const isPad = useMediaQuery("(max-width:1024px)");
  const isShowMobile = useMediaQuery("(min-width:1366px)");
  let hideTimer;
  const handleMouseEnter = (val: any, idx: any) => {
    if (val.title === "Login") return setShowDrawer(false);
    clearTimeout(hideTimer);
    setShowDrawer(true);
    setDrawerContent(idx + 1);
  };

  const handleMouseLeave = () => {
    hideTimer = setTimeout(() => {
      setShowDrawer(false);
      setDrawerContent(null);
    }, 300);
  };

  return (
    <>
      <HeaderStyled id="header">
        <HeaderContent>
          <img src={logo} className="logo" onClick={()=>{window.location.href =('https://bkvenergy.com/')}}/>
          {isPad ? (
            <div onClick={()=>setShowMenu(true)}>
              {!showMenu && <img width="30px" height="30px" src={menu} />}
            </div>
          ) : (
            <HeaderTitleItems>
              {HeaderTitleArray.map((item, idx) => (
                <HeaderTitleItem
                  onMouseEnter={() => handleMouseEnter(item, idx)}
                  onMouseLeave={handleMouseLeave}
                >
                  <a href={item.link}>{item.title}</a>
                </HeaderTitleItem>
              ))}
            </HeaderTitleItems>
          )}

          <RightSection>
            {isShowMobile && <a href="tel:18552584797">1 855 BKVE 4PWR</a>}
            <Button onClick={()=>window.open('https://enroll.bkvenergy.com/?promo=ORGDIR0001')}>
              <Typography fontWeight={600}>FIND YOUR POWER</Typography>
            </Button>
          </RightSection>
        </HeaderContent>
      </HeaderStyled>
      {isPad ? (
        <MobileDrawer isOpen={showMenu} handleChangeShow={()=>setShowMenu(false)}/>
      ) : (
        <PCDrawer
          isOpen={showDrawer}
          content={drawerContent}
          onMouseEnter={() => clearTimeout(hideTimer)}
          onMouseLeave={() => {
            setShowDrawer(false);
            setDrawerContent(null);
          }}
        />
      )}
    </>
  );
};
